import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { TaggingProvider } from '../../providers/posts/tagging.provider';

/**
 * Generated class for the ReversePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'stripHtml',
  pure: false,
})
export class StripHtmlPipe implements PipeTransform {
  constructor(public taggingProvider: TaggingProvider) {}

  /**
   * Takes a value and makes it lowercase.
   */
  transform(html: '') {
    var div = document.createElement('div');
    div.innerHTML = html;
    const clone = _.clone(div.textContent || div.innerText || '');
    div.remove();
    return clone;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/strip-html/strip-html.ts